export default __webpack_public_path__ + "static/media/icon_copy.41213930.svg";